function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { DrmProvider, DrmType } from '../../../../core/player/playout-data';
var _obj;
export var oneAppDrmConfig = (_obj = {}, _define_property(_obj, DrmType.Fairplay, {
    provider: DrmProvider.Keyos
}), _define_property(_obj, DrmType.Widevine, {
    provider: DrmProvider.Keyos
}), _define_property(_obj, DrmType.PlayReady, {
    provider: DrmProvider.Keyos
}), _obj);

//# sourceMappingURL=drm-config.js.map